define('components/handlers/tablink-ajax',[
    'jquery',
    '../util/reload-fragments'
],function(
    jQuery,
    reload
){
    $.extend(companyInfo.handlers,{

        'tablink-ajax': function( e ){
            e.preventDefault();

            var $el = jQuery(this);
            var panel = $(".panel-content.results");
            var url = $el.attr("href");
            var reloadType = panel.data("reload-type");

            setLoading(panel);
            reload( reloadType, url, function(){
                unsetLoading(panel);
            });

            function setLoading(el){
                el.addClass('loading');
            }

            function unsetLoading(el){
                el.removeClass('loading');
            }
        }

    });



});

